import React from 'react';
import cn from 'classnames';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import {
  Row,
  Col,
  Form,
  FormGroup,
  Input,
  Button,
  Breadcrumb,
  BreadcrumbItem,
  Alert,
  Collapse,
  Label,
} from 'reactstrap';
import Card from '../../Card/Card';
import FlowLink from '../FlowLink';
import FlowParkedDomain from '../FlowParkedDomain';
import FlowSubAccount from '../FlowSubAccount/FlowSubAccount';
import FlowAgencies from '../FlowAgencies';
import FlowAgencyBanner from '../FlowAgencyBanner';
import FlowTitle from '../FlowTitle';
import FlowSources from '../FlowSources';
import FlowOffers from '../FlowOffers';
import FlowLandingsTable from '../FlowLandingsTable';
import FlowPostback from '../FlowPostback';
import FlowTrafficback from '../FlowTrafficback';
import FlowFailAction from '../FlowFailAction';
import FlowTrackers from '../FlowTrackers';
import FlowToggleBtns from '../FlowToggleBtns';
import Hint from '../../Hint/Hint';
import AlertModal from '../../../modals/AlertModal/AlertModal';
import DomainUrl from '../../Domains/DomainUrl';
import DomainDisclaimer from '../../Domains/DomainDisclaimer';
import OfferTopLink from '../../Offer/OfferTopLink';
import CustomControl from '../../CustomControl/CustomControl';
import TransitsFeatures from '../TransitsFeatures';
import FlowQRCode from '../FlowQRCode';
import { FMessage } from '../../../hoc/IntlComponents';
import PrelandersConstructorDisclaimer from '../../Landings/PrelandersConstructorDisclaimer';
import FlowDeepLink from '../FlowDeepLink';
import Icon from '../../Icon/Icon';
import CopyContent from '../../common/CopyContent';
import FlowDirectLinkForm from '../FlowDirectLinkForm';
import FlowWarning from '../FlowWarning';
import DomainReplicaWarning from '../../Domains/DomainReplicaWarning';
import FlowDirectLinkTour from '../FlowDirectLinkTour';
import FlowTikTokControls from '../FlowTikTokControls';
import NewFlowLandingFeatures from '../NewFlowLandingFeatures';
import NewIFrameConstructor from '../NewIFrameConstructor';
import StickyHeader from '../../../hoc/StickyHeader';

const View = ({
  data: {
    stream,
    subAccount,
    errors,
    isClick,
    modal,
    message,
    type,
    iframeConstructorModalOpen,
    use_transit_service,
    trackersDropdownOpen,
    isExtraSettingsOpen,
    loading,
    offers,
    sites,
    offer,
    settings,
    profile,
    isEdit,
    isCdn,
    isUserBlocked,
    site_key,
    landingsABTestEnabled,
    transitsABTestEnabled,
    deepLink,
    isPrelandersCollapseOpen,
    isUsingDirectLinkWithoutRedirectLanding,
    domainParking,
    showDirectLinkTour,
    streamLandingSettings,
    currentLandingSettings,
    currentIFrameSettings,
    currentLandingSettingsOverrides,
  },
  topBundle,
  handleSubmit,
  getComputedLink,
  handleSubAccountChange,
  _alertRefs,
  handleDomainCheck,
  handleDomainChange,
  getParkingType,
  getOffersWithNoReplics,
  handleOfferChange,
  handleSiteChange,
  handleAgencyChange,
  sortLandingsByTotalCr,
  handleLandingChange,
  toggleIframeConstructorModal,
  handleTransitsComebackerChange,
  handleTransitFeatureChange,
  handleNewsShowcaseSettingsChange,
  handleUseTransitsChange,
  handleTransitChange,
  toggleExtraSettings,
  handlePostbackChange,
  handleStatusChange,
  handlePixelChange,
  handleTrafbackUrlChange,
  handleFailActionChange,
  handleTrackerChange,
  toggleTrackersDropdown,
  toggleModal,
  handleChange,
  setTopLink,
  handleDeepLinkChande,
  togglePrelandersCollapse,
  moveIframeConstructorToEnd,
  handleDirectLinkSubdomainChange,
  toggleDirectLinkWithoutRedirectLandingUsage,
  checkDirectLinkWithoutRedirect,
  showVkCabinetSubtext,
  handleClickVkWarningLink,
  showWarning,
  replicaOffersIds,
  domainParkingToggle,
  onDomianParkingInputChange,
  handleDirectLinkTourClose,
  handleIsTikTokChange,
  handleCurrentLandingSettingsChange,
  handleCurrentLandingSettingsOverridesChange,
  iframeConstructorLoading,
  handleIFrameConstructorSave,
}) => (
  <StickyHeader
    headerSelector=".flow-form-sticky-header"
    offsetTop={30}
    disabled={!stream.editable || loading}
  >
    <Form className="flow-form" onSubmit={handleSubmit}>
      <Card.Header className="flow-form-sticky-header">
        <div className="flow-form-wrapper-header">
          {isEdit ? (
            stream.title
          ) : (
            <FormattedMessage id="flow.breadcrumb" defaultMessage="Create flow" />
          )}
          <div className="confirm-btn-row">
            <Button color="primary" disabled={stream.offerId === 0 || loading || isUserBlocked}>
              {isEdit ? (
                <FormattedMessage id="flow.buttons.save" defaultMessage="Save a flow" />
              ) : (
                <FormattedMessage id="flow.buttons.create" defaultMessage="Create a flow" />
              )}
            </Button>
          </div>
        </div>
      </Card.Header>
      <Card className="flow-form-wrapper" loading={loading}>
        <Card.Body>
          {isEdit && (
            <h3>
              <FormattedMessage id="flow.title.edit" defaultMessage="Edit flow" />
            </h3>
          )}
          {isEdit && (
            <>
              {stream.editable &&
              showWarning &&
              !stream.directLinkLandingWithoutRedirect &&
              !stream.directLinkLanding ? (
                <FlowWarning />
              ) : null}

              <div>
                <div className="flow-form-wrapper-links">
                  <Col>
                    {/* Link */}
                    {/* {stream.link &&
                      !stream.directLinkLandingWithoutRedirect &&
                      !stream.directLinkLanding && <FlowLink link={getComputedLink(stream.link)} />} */}

                    {stream.directLinkLandingWithoutRedirect && (
                      <FlowLink
                        link={getComputedLink(
                          stream.directLinkLandingWithoutRedirect,
                          '&callsubid=',
                        )}
                        id="flow.form.direct-link-without-redirect.title"
                        defaultMessage="Direct link without redirect"
                      />
                    )}

                    {stream.directLinkAffRid && (
                      <FlowLink
                        link={getComputedLink(stream.directLinkAffRid, '&aff_subid=')}
                        id="flow.form.direct-link.title"
                        defaultMessage="Direct link without redirect"
                      />
                    )}

                    <div className="flow-form-wrapper-links">
                      <FlowSubAccount onSubAccountChange={handleSubAccountChange} />
                    </div>
                  </Col>

                  {stream.editable ? (
                    <div className="flow-qr-recommend-wrapper">
                      {stream.link ? <FlowQRCode link={getComputedLink(stream.link)} /> : null}
                    </div>
                  ) : (
                    <FlowAgencyBanner agency={stream.agency} />
                  )}
                </div>

                <div className="flow-form-wrapper-links">
                  {settings.clickDomains &&
                    settings.clickDomains.length > 0 &&
                    !stream.directLinkLanding && (
                      <FlowParkedDomain
                        subAccount={subAccount}
                        encId={stream.encId}
                        domains={settings.clickDomains}
                      />
                    )}
                </div>

                {/* Direct Landing Link */}
                {stream.directLinkLanding && (
                  <FlowLink
                    id="flow.form.direct-landing-link"
                    defaultMessage="Landing Link"
                    link={getComputedLink(stream.directLinkLanding, '&callsubid=')}
                  />
                )}

                {/* Direct Prelander Link */}
                {stream.directLinkPrelander && (
                  <FlowLink
                    id="flow.form.direct-prelander-link"
                    defaultMessage="Prelander Link"
                    link={getComputedLink(stream.directLinkPrelander, '&callsubid=')}
                  />
                )}

                {/* {!isCdn && (
                <FlowDeepLink onDeepLinkChange={handleDeepLinkChande} deepLink={deepLink} />
              )} */}
              </div>
            </>
          )}
          <div>
            {/* {!isEdit && !isClick && <FlowToggleBtns />} */}

            <div>
              {/* Domain */}
              {isClick && (
                <div ref={_alertRefs.rotator_domain}>
                  <DomainUrl
                    url={stream.rotator_domain}
                    isEdit={isEdit}
                    onCheckDomain={handleDomainCheck}
                    onUrlChange={handleDomainChange}
                    error={errors.rotator_domain}
                  />
                  <div ref={_alertRefs.title}>
                    <FlowTitle
                      title={stream.title}
                      onChangeTitle={handleChange}
                      error={errors.title}
                    />
                  </div>

                  {/* Offers */}
                  <div ref={_alertRefs.offers}>
                    {isEdit ? (
                      <FormGroup className="stream-offer-select">
                        <FormattedMessage id="flow.form.offer" defaultMessage="Offer" />
                        <Input type="select" name="offer_id" defaultValue={offer.id} disabled>
                          <option value={offer.id}>{offer.title}</option>
                        </Input>
                      </FormGroup>
                    ) : (
                      <FlowOffers
                        className="stream-offer-select"
                        offerId={stream.offerId}
                        offers={getOffersWithNoReplics(offers)}
                        onOfferChange={handleOfferChange}
                        error={errors.offer}
                      />
                    )}
                  </div>

                  {replicaOffersIds?.length > 0 ? <DomainReplicaWarning /> : null}

                  <div className="domains-tutorial">
                    <div className="domains-tutorial--header">
                      <h3 className="domains-tutorial--title">
                        <FormattedMessage
                          id="domains.tutorial.title"
                          defaultMessage="Domain parking guide"
                        />
                      </h3>
                    </div>
                    <div className="domains-tutorial--body">
                      <p className="domains-tutorial--intro">
                        <FormattedMessage
                          values={{ steps: 4 }}
                          id="domains.tutorial.intro"
                          defaultMessage="To park domain in OFFERRUM you need to perform a simple setup in your domain registrator office."
                        />
                      </p>
                      <ul className="domains-tutorial--steps list-unstyled">
                        <li className="domains-tutorial--step">
                          <FormattedMessage
                            id="domains.tutorial.step.1"
                            defaultMessage="1. Buy a domain and setup the following NS records in registrator panel:"
                          />
                          <br />
                          <span id="domain-tutorial--ns1" className="domains-tutorial--link">
                            ns1.mrrffo.com&nbsp;
                          </span>
                          <CopyContent
                            delay={500}
                            content="ns1.mrrffo.com"
                            iconType="copy-2"
                            copyMessageId="main"
                            tooltipMessageId="main.copy"
                            tooltipTargetId="domain-tutorial--ns1"
                          />
                          <br />
                          <span id="domain-tutorial--ns2" className="domains-tutorial--link">
                            ns2.mrrffo.com&nbsp;
                          </span>
                          <CopyContent
                            delay={500}
                            content="ns2.mrrffo.com"
                            iconType="copy-2"
                            copyMessageId="main"
                            tooltipMessageId="main.copy"
                            tooltipTargetId="domain-tutorial--ns2"
                          />
                          <p className="domains-tutorial--small">
                            <FormattedMessage
                              id="domains.tutorial.step.1.disclaimer"
                              defaultMessage="Wait for the changes to take effect. This process can last up to 72 hours, usually 60 minutes."
                            />
                          </p>
                        </li>
                        <li className="domains-tutorial--step">
                          <FormattedMessage
                            values={{ stepID: 2 }}
                            id="domains.tutorial.step.2"
                            defaultMessage="2. Choose parking domain type."
                          />{' '}
                        </li>
                        <li className="domains-tutorial--step">
                          <FormattedMessage
                            values={{ stepID: 3 }}
                            id="domains.tutorial.step.3"
                            defaultMessage="3. Past your domain's URL and press the Add domain button;"
                          />
                        </li>
                      </ul>
                    </div>
                  </div>
                  <DomainDisclaimer type={type} parkingType={getParkingType()} />
                </div>
              )}

              {!isClick && (
                <>
                  {/* Title */}
                  <div ref={_alertRefs.title}>
                    <FlowTitle
                      title={stream.title}
                      onChangeTitle={handleChange}
                      error={errors.title}
                    />
                  </div>

                  {/* Offers */}
                  <div ref={_alertRefs.offers}>
                    {isEdit ? (
                      <FormGroup className={cn('form-group-upper-label', 'stream-offer-select')}>
                        <Label for="flow.form.offer">
                          <FormattedMessage id="flow.form.offer" defaultMessage="Offer" />
                        </Label>
                        <Input type="select" name="offer_id" defaultValue={offer.id} disabled>
                          <option value={offer.id}>{offer.title}</option>
                        </Input>
                      </FormGroup>
                    ) : (
                      <FlowOffers
                        className="stream-offer-select"
                        offerId={stream.offerId}
                        offers={getOffersWithNoReplics(offers)}
                        onOfferChange={handleOfferChange}
                        error={errors.offer}
                      />
                    )}
                  </div>
                </>
              )}

              {/* Agency */}
              {!isEdit &&
                !isClick &&
                Array.isArray(settings.agencies) &&
                settings.agencies.length > 0 && (
                  <>
                    <FlowAgencies
                      className="no-margin"
                      agency={stream.agency}
                      agencies={settings.agencies}
                      onAgencyChange={handleAgencyChange}
                      disabled={isUsingDirectLinkWithoutRedirectLanding || domainParking.enabled}
                    />
                    {showVkCabinetSubtext ? (
                      <div className="pt-2">
                        <FMessage id="flow.form.agency.vk.warning" />
                        <a
                          onClick={handleClickVkWarningLink}
                          className="flow-agency-warning-link"
                          tabIndex={1}
                        >
                          <FMessage id="flow.form.agency.vk.warning.link" />
                        </a>
                      </div>
                    ) : null}
                  </>
                )}

              {/* TikTok */}
              {offer.modifies?.is_cdn ? (
                <FlowTikTokControls
                  isStreamTikTok={stream.isTikTok}
                  settings={currentLandingSettings}
                  handleCurrentLandingSettingsChange={handleCurrentLandingSettingsChange}
                  handleIsTikTokChange={handleIsTikTokChange}
                />
              ) : null}
            </div>
          </div>
        </Card.Body>

        {/* Landings */}
        {offer.landings && offer.landings.length > 0 && (
          <div id="landings-card">
            {isCdn && (
              <Card.Body>
                <h3>
                  <FormattedMessage id="flow.landings" defaultMessage="Landings" />
                </h3>

                {/* Landing Features */}
                <Row className="flex-wrap-reverse">
                  {offer.modifies && streamLandingSettings && (
                    <Col lg="7">
                      <NewFlowLandingFeatures
                        streamLandingSettings={streamLandingSettings}
                        currentLandingSettings={currentLandingSettings}
                        onFeaturesChange={handleCurrentLandingSettingsChange}
                        isStreamTikTok={stream.isTikTok}
                        abEnabled={landingsABTestEnabled || transitsABTestEnabled}
                        onOverridesChange={handleCurrentLandingSettingsOverridesChange}
                        currentLandingSettingsOverrides={currentLandingSettingsOverrides}
                      />
                    </Col>
                  )}

                  {offer && offer.top_bundle && (
                    <Col lg="5">
                      <OfferTopLink
                        item={offer.top_bundle}
                        offer={offer}
                        onClick={setTopLink}
                        inFlow={true}
                        disabled={stream.agency}
                      />
                    </Col>
                  )}
                </Row>
              </Card.Body>
            )}

            <Card.Body>
              <h3>
                <FormattedMessage id="flow.landings" defaultMessage="Landings" />
              </h3>
              <fieldset disabled={!stream.editable}>
                <FlowLandingsTable
                  name="landing"
                  landingsTableType="landings"
                  landings={moveIframeConstructorToEnd(offer.landings)}
                  domains={sortLandingsByTotalCr(offer.domains.landings)}
                  checked={stream.landingsId}
                  checkedTransits={stream.transitsId}
                  abTestEnabled={landingsABTestEnabled}
                  abTestDisabled={isUsingDirectLinkWithoutRedirectLanding || domainParking.enabled}
                  topItem={topBundle.best_landing}
                  onLandingChange={handleLandingChange}
                  offerId={offer.id}
                  abTest={stream.abTest}
                  toggleIframeConstructorModal={toggleIframeConstructorModal}
                  multiple
                  site_key={site_key}
                  offer={offer}
                  streamId={stream.id}
                  streamLandings={stream.landings}
                  inFlow
                />
              </fieldset>
            </Card.Body>
          </div>
        )}
      </Card>

      {offer.direct_link_without_redirect && !isClick && (
        <FlowDirectLinkForm
          direct_link_without_redirect={offer.direct_link_without_redirect}
          value={stream.direct_link_without_redirect}
          onChange={handleDirectLinkSubdomainChange}
          enable={isUsingDirectLinkWithoutRedirectLanding}
          usageToggle={toggleDirectLinkWithoutRedirectLandingUsage}
          error={errors.directLinkLanding}
          innerRef={_alertRefs.directLinkLanding}
          checkDomain={checkDirectLinkWithoutRedirect}
          domainParking={domainParking}
          domainParkingToggle={domainParkingToggle}
          onDomianParkingInputChange={onDomianParkingInputChange}
          offerCategories={offer.categories}
        />
      )}

      {errors.landings && (
        <div ref={_alertRefs.landings}>
          <Alert color="danger">{errors.landings}</Alert>
        </div>
      )}

      {/* Transits */}
      {offer.transits && offer.transits.length > 0 && !stream.agency && (
        <Card>
          <Card.Header
            className={cn('prelanders-collapse-header', {
              'prelanders-collapse-header--open': isPrelandersCollapseOpen,
            })}
          >
            <FormattedMessage id="flow.prelanders" defaultMessage="Prelanders" />
            <Button
              type="button"
              color="link"
              size="sm"
              className="btn-toggle"
              onClick={togglePrelandersCollapse}
            >
              <Icon type="chevron-up" />
            </Button>
          </Card.Header>
          <Collapse isOpen={isPrelandersCollapseOpen}>
            <TransitsFeatures
              disabled={
                !stream.editable ||
                !use_transit_service ||
                isUsingDirectLinkWithoutRedirectLanding ||
                domainParking.enabled
              }
              featuresList={stream.transitFeatures}
              toggleComebacker={handleTransitsComebackerChange}
              transit_comebacker={stream.transit_comebacker}
              handleTransitFeatureChange={handleTransitFeatureChange}
              handleNewsShowcaseSettingsChange={handleNewsShowcaseSettingsChange}
            />

            <Card.Body>
              {profile && profile.use_transit_service === false && (
                <div className="flow-transit-service-control">
                  <FormGroup>
                    <CustomControl
                      id="use_transit_service"
                      name="use_transit_service"
                      className="custom-control-xs"
                      onChange={handleUseTransitsChange}
                      checked={use_transit_service}
                      value="1"
                    >
                      <FormattedMessage
                        id="profile.use_transit_service"
                        defaultMessage="Enable service «1001transits for affiliates»"
                      />
                    </CustomControl>
                  </FormGroup>
                </div>
              )}
              <fieldset
                disabled={
                  !stream.editable ||
                  !use_transit_service ||
                  isUsingDirectLinkWithoutRedirectLanding ||
                  domainParking.enabled
                }
              >
                <FlowLandingsTable
                  name="transits"
                  landingsTableType="transits"
                  landings={offer.transits}
                  domains={offer.domains.transits}
                  checked={stream.transitsId}
                  checkedLandings={stream.landingsId}
                  abTestEnabled={transitsABTestEnabled}
                  onLandingChange={handleTransitChange}
                  topItem={topBundle.best_prelanding}
                  offerId={offer.id}
                  abTest={stream.abTest}
                  multiple
                  site_key={site_key}
                  offer={offer}
                  streamId={stream.id}
                  inFlow
                />
              </fieldset>
            </Card.Body>

            <Card.Footer>
              <ul className="list-inline no-margin">
                <li className="list-inline-item">
                  <a href="#" className="pseudo-link" onClick={(e) => handleTransitChange(0, e)}>
                    <FormattedMessage
                      id="flow.form.disable-prelanders"
                      defaultMessage="Reset selection"
                    />
                  </a>
                </li>
              </ul>

              {/* <PrelandersConstructorDisclaimer /> */}
            </Card.Footer>
          </Collapse>
        </Card>
      )}

      <Card className={cn('extra-settings', { isOpen: isExtraSettingsOpen, loading })}>
        <Card.Body>
          <div onClick={toggleExtraSettings} className="extra-settings-toggle">
            <h3>
              <FMessage id="flow.extra-settings.toggle" />
            </h3>
            <div className="pseudo-link">
              {isExtraSettingsOpen ? (
                <FMessage id="flow.extra-settings.toggle-link-hidden" />
              ) : (
                <FMessage id="flow.extra-settings.toggle-link" />
              )}
            </div>
          </div>

          <Collapse isOpen={isExtraSettingsOpen} className="flow-form-collapse">
            <Card.Body className="no-padding">
              {/* Extra settings */}

              {/* Postback */}
              <FlowPostback
                streamId={stream.id}
                postback={stream.postback}
                streamPixels={stream.pixels}
                statuses={settings.postBackStatuses}
                streamStatuses={stream.statuses}
                pixels={offer.pixels}
                settings={settings}
                onPostbackChange={handlePostbackChange}
                onStatusChange={handleStatusChange}
                onPixelChange={handlePixelChange}
                className={cn('flow-postback-card', { isOpen: isExtraSettingsOpen })}
              />

              {/* Trafficback */}
              {/* <Card className={cn('flow-trafficback-card', { isOpen: isExtraSettingsOpen })}>
              <h4>
                <FormattedMessage id="flow.form.trafficback" defaultMessage="TrafficBack" />
                <FormattedMessage
                  id="flow.form.trafficback.hint"
                  defaultMessage="In this field you can specify an arbitrary URL, to which the user will be redirected if it doesn’t match the offer’s geography"
                >
                  {(hint) => <Hint id="trafficback-hint" text={hint} />}
                </FormattedMessage>
              </h4>

              {stream.agency === null ? (
                <Card.Body className="no-padding">
                  <FlowTrafficback
                    url={stream.trafficback}
                    onChangeTrafficbackUrl={handleTrafbackUrlChange}
                    disabled={isUsingDirectLinkWithoutRedirectLanding || domainParking.enabled}
                  />
                </Card.Body>
              ) : null}

              <Card.Body className="no-padding">
                <FlowFailAction
                  availableFailActions={stream.failActions}
                  onChangeFailAction={handleFailActionChange}
                  offers={offers}
                  disabled={
                    isUsingDirectLinkWithoutRedirectLanding ||
                    domainParking.enabled ||
                    stream.agency !== null
                  }
                  offerId={stream.offerId}
                  streamId={stream.id}
                  isAgencyStream={stream.agency !== null}
                />
              </Card.Body>
            </Card> */}
            </Card.Body>

            {/* External Stats */}
            {settings.trackers &&
              (isCdn ||
                offer.categories?.includes(47) ||
                offer.categories?.includes(105) ||
                offer.id === 28176 ||
                offer.id === 30444 ||
                offer.id === 31449 ||
                offer.categories?.includes(103)) && (
                <Card.Body className="no-padding">
                  <FlowTrackers
                    className={cn('flow-trackers-card', { isOpen: isExtraSettingsOpen })}
                    trackers={settings.trackers.tracking}
                    values={stream.trackers}
                    onTrackerChange={handleTrackerChange}
                    readOnly={!stream.editable}
                    toggleTrackersDropdown={toggleTrackersDropdown}
                    trackersDropdownOpen={trackersDropdownOpen}
                  />
                </Card.Body>
              )}
          </Collapse>
        </Card.Body>
      </Card>

      <AlertModal open={modal} message={message} onClose={toggleModal} />
      <NewIFrameConstructor
        isOpen={iframeConstructorModalOpen}
        toggle={toggleIframeConstructorModal}
        streamLink={getComputedLink(stream.link)}
        streamLandingSettings={streamLandingSettings}
        currentIFrameSettings={currentIFrameSettings}
        currentLandingSettingsOverrides={currentLandingSettingsOverrides}
        handleCurrentLandingSettingsOverridesChange={handleCurrentLandingSettingsOverridesChange}
        iframeConstructorLoading={iframeConstructorLoading}
        handleIFrameConstructorSave={handleIFrameConstructorSave}
      />
      {showDirectLinkTour ? (
        <FlowDirectLinkTour handleDirectLinkTourClose={handleDirectLinkTourClose} />
      ) : null}
    </Form>
  </StickyHeader>
);

export default View;
